import { createAction } from "redux-actions";

export function changeLanguageAction(lang) {
  localStorage.setItem("lang", lang);
  return {
    type: "CHANGE_LANGUAGE",
    payload: lang,
  };
}

export const reset = createAction("RESET");
export const logout = createAction("REQ_LOGOUT_V2");
